<template>
    <section class="table-responsive">
        <div class="heatmap-table">
            <span class="trow">
                <span class="tcolumn"></span>
                <span v-for="head in labelsX" v-bind:key="head" class="tcolumn">
                    {{head}}
                </span>
            </span>
            <span v-for="row in labelsY" v-bind:key="row.id" class="trow">
                <span class="tcolumn">
                    {{row.name}}
                </span>
                <span v-for="i in matrix[row.id]" v-bind:key="i" class="tcolumn data" :style="{'background-color': color(i)}">

                </span>
            </span>
        </div>
        <div class="legend-box">
            <div class="legend-text">No activity&nbsp;</div>
            <div class="legend" :style="{'background-color': color(null)}"></div>
            <div class="legend" v-for="l in legend" :style="{'background-color': color(l)}" v-bind:key="l"></div>
            <div class="legend-text">&nbsp;{{this.max}}</div>
        </div>

    </section>
</template>

<script>
    import {flatten, min, max} from 'lodash'

    export default {
        name: 'Heatmap',
        props: [
            'data'
        ],
        data () {
            return {
                matrix: [],
                labelsX: [],
                labelsY: [],
                min: 0,
                max: 0
            }
        },
        computed: {
            legend () {
                const step = (this.max - this.min) / 4
                if (this.max - this.min < 5) {
                    return [
                        this.min,
                        this.min + 1,
                        this.min + 2,
                        this.min + 3,
                        this.min + 4
                    ]
                }
                return [
                    this.min,
                    Math.round(this.min + step),
                    Math.round(this.min + 2 * step),
                    Math.round(this.min + 3 * step),
                    this.max
                ]
            }
        },
        watch: {
            data (data) {
                this.matrix = data.data
                this.labelsX = data.labels.x
                let i = 0
                this.labelsY = data.labels.y.map(x => { return {id: i++, name: x} })
                const flattened = flatten(this.matrix)
                this.max = max(flattened)
                this.min = min(flattened)
            }
        },
        methods: {
            color (value) {
                if (value == null) {
                    return 'rgba(0, 0, 0, 0.1)'
                }
                const h = 136
                const s = 60
                const min = 0.1 * 100
                const max = 0.9 * 100
                if (this.max - this.min === 0) {
                    return `hsl(${h} ,${s}%, ${min}%)`
                }
                const l = max - Math.floor((((value - this.min) / (this.max - this.min))) * (max - min))
                return `hsl(${h} ,${s}%, ${l}%)`
            }
        }
    }
</script>

<style scoped lang="scss">
    .heatmap-table {
        display: table;
        margin: 0px auto 10px auto;
        height: 100%;
        .trow {
            display: table-row;

            .tcolumn {
                font-size: 12px;
                padding: 2px 2px;
                display: table-cell;

                &.data {
                    border: 1px solid white;
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    .legend-box {
        text-align: center;
        margin-bottom: 10px;

        .legend {
            width: 20px;
            height: 10px;
            display: inline-block;
        }
        .legend-text {
            padding: 4px 2px;
            display: inline-block;
        }
    }
</style>
